import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialog as MatDialog,
	MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import {
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	MyLoadsTable,
	RestService,
} from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

export const UPDATE_TYPE: any = {
	CUSTOMER: 'CUSTOMER',
	CARRIER: 'CARRIER',
};

@Component({
	selector: 'app-load-actions-dialog',
	templateUrl: './load-actions-dialog.component.html',
	styleUrls: ['./load-actions-dialog.component.scss'],
})
export class LoadActionsDialogComponent implements OnInit {
	UPDATE_TYPE = UPDATE_TYPE;
	selectedCustomer: any = null;
	selectedCarrier: any = null;
	isRequestInProgress: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<LoadActionsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService
	) {}

	closeDialog(data: any = null): void {
		this.dialogRef.close(data);
	}

	ngOnInit() {}

	disableUpdate() {
		switch (this.data.updateField) {
			case UPDATE_TYPE.CUSTOMER:
				return IS_NULL_OR_UNDEFINED(this.selectedCustomer);
			case UPDATE_TYPE.CARRIER:
				return IS_NULL_OR_UNDEFINED(this.selectedCarrier);
			default:
				return false;
		}
	}

	setCarrier(carrier: any) {
		this.selectedCarrier = carrier;
	}

	setCustomer(customer: any) {
		this.selectedCustomer = customer;
	}

	update() {
		this.isRequestInProgress = true;
		let payload: any = {
			loadIds: this.data.selectedLoads.map((load) => load.loadId),
		};
		switch (this.data.updateField) {
			case UPDATE_TYPE.CUSTOMER:
				payload.customerId = this.selectedCustomer.id;
				break;
			case UPDATE_TYPE.CARRIER:
				payload.carrierId = this.selectedCarrier.id;
				break;
		}
		const url = this.urlService.bulkUpdateLoads();
		this.restService.PUT(url, payload).subscribe(
			(response) => {
				this.utilService.showSnackbar(
					'Loads updated successfully.',
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				this.closeDialog({
					data: response.data,
					updateField: this.data.updateField,
					customer: this.selectedCustomer,
					carrier: this.selectedCarrier,
				});
				this.isRequestInProgress = false;
			},
			(error) => {
				this.utilService.showSnackbar('Unable to update tasks.', SNACKBAR.ERROR, SNACKBAR.ACTION);
				this.isRequestInProgress = false;
			}
		);
	}
}
